var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-edit',_vm._g(_vm._b({attrs:{"title":_vm.userName,"name":"users-edit","toptitle":_vm.$t('users.form.edit')}},'base-edit',_vm.$attrs,false),_vm.$listeners),[_c('users-form',{attrs:{"workspaceUser":_vm.workspaceUser,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }